import { useRef } from 'react';
import { useUser } from '../../../hooks/useUser';
import { useMessages } from '../../../hooks/useMessages';
import { ChatMessages } from '../../../interfaces/userInterfaces';
import { initiateChat, uploadNewMessage } from '../../../services/fetch-utils';

interface InitializeChatProps {
  userToMessage: string;
}

export const InitializeChat: React.FC<InitializeChatProps> = ({ userToMessage }) => {
  const { user } = useUser();
  const initChatRef = useRef<HTMLInputElement>(null);
  const {
    setChatMessages,
    chatMessages,
    listOfOpenChats,
    setActiveChatId,
    setActiveOpenChat,
    setListOfOpenChats,
  } = useMessages();

  const beginChat = async (user_1: string, user_2: string) => {
    const beginChat = await initiateChat(user_1, user_2);

    if (
      beginChat &&
      beginChat.status === 201 &&
      beginChat.data &&
      initChatRef?.current?.value !== undefined
    ) {
      const newChatObject = { ...beginChat.data[0], messages: [{} as ChatMessages] };
      setChatMessages([]);
      setActiveChatId(beginChat.data[0].chat_id);
      setActiveOpenChat(newChatObject);
      setListOfOpenChats([...listOfOpenChats, newChatObject]);

      const newChatObj = {
        chat_id: beginChat.data[0].chat_id,
        sender: beginChat.data[0].user_1,
        receiver: beginChat.data[0].user_2,
        message: initChatRef.current.value,
        read: false,
      };

      await uploadNewMessage(newChatObj);
    } else {
      console.log('IS MESSAGE UNDEFINED?: ', initChatRef.current?.value);
      console.log('WHAT IS BEGIN CHAT?: ', beginChat);
    }
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    beginChat(user!.username, userToMessage);
  };

  return (
    <form id="initialize-chat-form" onSubmit={handleSubmit}>
      <input
        className="message-input-row"
        placeholder="Say something nice..."
        ref={initChatRef}
      ></input>
      <button className="message-send-btn">Begin Chat</button>
    </form>
  );
};
